import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CustomerLoyaltyAccount, CustomerLoyaltyAccountCreate, CustomerLoyaltyAccountFilter } from '../data/customerLoyaltyAccount';

export function createCustomerLoyaltyAccountService(client: AxiosInstance) {
  return createCrudService<CustomerLoyaltyAccount, CustomerLoyaltyAccountCreate, CustomerLoyaltyAccountFilter>(
    client,
    '/crm/CustomerLoyaltyAccount',
    'id',
  );
}

export type CustomerLoyaltyAccountService = CrudService<CustomerLoyaltyAccount, CustomerLoyaltyAccountCreate, CustomerLoyaltyAccountFilter>;
